import http from "./httpService";

class UserWalkthroughService {
  async getUserWalkthrough() {
    return await http.get("/user-walkthrough");
  }

  async updateUserWalkthrough(data) {
    return await http.put("/user-walkthrough", data);
  }

  /**
   * Record walkthrough data
   * @param {RecordWalkthroughRequest} data - Walkthrough data to record
   * @returns {Promise<BaseApiResponse<RecordWalkthroughResponse>>}
   */
  async recordWalkthrough(data) {
    return await http.post("/user-walkthrough/record", data);
  }

  /**
   * Choose user role
   * @param {ChooseRoleRequest} data - Role selection data
   * @returns {Promise<BaseApiResponse<ChooseRoleResponse>>}
   */
  async chooseRole(data) {
    return await http.post("/user-walkthrough/choose-role", data);
  }

  /**
   * Get current user's walkthrough data
   * @returns {Promise<BaseApiResponse<UserWalkthroughData>>}
   */
  async getMyWalkthrough() {
    return await http.get("/user-walkthrough/me");
  }

  /**
   * Get schools by name search
   * @param {string} name - School name to search for
   * @returns {Promise<BaseApiResponse<SchoolData[]>>}
   */
  async getSchools(name) {
    return await http.get(`/schools-master-by-google?search=${name}`);
  }
}

export default new UserWalkthroughService();
